const get = (key: string): string | null =>
  localStorage.getItem(key) ?? sessionStorage.getItem(key);

const set = (key: string, value: string): void => {
  localStorage.setItem(key, value);
  sessionStorage.setItem(key, value);
};

const remove = (key: string): void => {
  localStorage.removeItem(key);
  sessionStorage.removeItem(key);
};

const clear = (): void => {
  localStorage.clear();
  sessionStorage.clear();
};

export default {
  get,
  set,
  remove,
  clear,
};
